{
  "pending": "čakajúce"
}
